module.exports = __webpack_public_path__ + "static/img/m_role.d2e547a.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/mobile_img/role3/xk/m_role.png
// module id = J/w7
// module chunks = 7